import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardAnnouncementIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 14.1368L5.57465 20.4353C5.61893 20.6125 5.64107 20.701 5.66727 20.7784C5.92317 21.5339 6.60352 22.0651 7.39852 22.1301C7.4799 22.1368 7.5712 22.1368 7.75379 22.1368C7.98244 22.1368 8.09677 22.1368 8.19308 22.1274C9.145 22.0351 9.89834 21.2817 9.99066 20.3298C10 20.2335 10 20.1192 10 19.8905V5.63675M18.5 13.6368C20.433 13.6368 22 12.0697 22 10.1368C22 8.20376 20.433 6.63675 18.5 6.63675M10.25 5.63675H6.5C4.01472 5.63675 2 7.65147 2 10.1368C2 12.622 4.01472 14.6368 6.5 14.6368H10.25C12.0164 14.6368 14.1772 15.5836 15.8443 16.4924C16.8168 17.0226 17.3031 17.2876 17.6216 17.2486C17.9169 17.2125 18.1402 17.0798 18.3133 16.8379C18.5 16.5769 18.5 16.0548 18.5 15.0105V5.26304C18.5 4.21875 18.5 3.6966 18.3133 3.43564C18.1402 3.19365 17.9169 3.06105 17.6216 3.02488C17.3031 2.98587 16.8168 3.25095 15.8443 3.78111C14.1772 4.68986 12.0164 5.63675 10.25 5.63675Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardAnnouncementIcon;
